/* unplugin-vue-components disabled */import script from "./InvoiceMonthlyCustomerWorkbench.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceMonthlyCustomerWorkbench.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceMonthlyCustomerWorkbench.vue?vue&type=style&index=0&id=52403a8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52403a8a"]])

export default __exports__